import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c5d6364a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c5d6364a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d6364a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5d6364a')) {
      api.createRecord('c5d6364a', component.options)
    } else {
      api.reload('c5d6364a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c5d6364a&scoped=true&", function () {
      api.rerender('c5d6364a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ABgtia4CLZdL/JS/comp/GuestBox.vue"
export default component.exports